let StringsMixin = {
  methods: {
    getFullName(nombre, apellidos, razonSocial) {
      let fullName = "";
      if (nombre) fullName += nombre;
      if (nombre && apellidos) fullName += " ";
      if (apellidos) fullName += apellidos;
      if (!fullName && razonSocial) fullName = razonSocial;
      return fullName;
    },
    getFullNameByType(nombre, apellidos, razonSocial, esEntidad) {
      let fullName = "";
      if (esEntidad) {
        if (razonSocial) {
          fullName += razonSocial;
        } else {
          if (nombre) fullName += nombre;
          if (nombre && apellidos) fullName += " ";
          if (apellidos) fullName += apellidos;
        }
      } else {
       fullName = this.getFullName(nombre, apellidos, razonSocial);
      }
      return fullName;
    },
    getNameByType(nombre, razonSocial, esEntidad) {
      let fullName = "";
      if (esEntidad) {
        if (razonSocial) {
          fullName += razonSocial;
        } else {
          if (nombre) fullName += nombre;
        }
      } else {
        if (nombre) fullName += nombre;
        if (!fullName && razonSocial) fullName = razonSocial;
      }
      return fullName;
    }
  }
};
export default StringsMixin;